import XFileUpload from './XFileUpload';
import { FileUploadBtn } from '../ui-control/fileUploadBtn';
import DropboxChooserButton from './DropboxChooserButton';

const UploadButtonGroup = ({
  uploadButtonText = 'Upload File',
  uploadButtonProps = {},
  accept,
  multiple = false,
  disabled = false,
  isLoading = false,
  onFileSelect,
  onDropboxSuccess,
  dropboxAcceptedFileTypes,
  dropboxMultiselect,
  className = '',
  dropboxClassName = '',
  inputName,
  inputProps = {},
  renderUploadButton
}) => {
  const uploadButtonNode = renderUploadButton
    ? renderUploadButton({ disabled, isLoading })
    : (
      <FileUploadBtn
        text={uploadButtonText}
        isDisabled={disabled}
        isLoading={isLoading}
        {...uploadButtonProps}
      />
    );

  return (
    <div className={`flex items-center gap-2 ${className}`.trim()}>
      <div className="inline-block">
        {uploadButtonNode}
        <XFileUpload
          name={inputName}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onFileSelect={onFileSelect}
          {...inputProps}
        />
      </div>
      {onDropboxSuccess && (
        <div className="relative z-2">
          <DropboxChooserButton
            acceptedFileTypes={dropboxAcceptedFileTypes ?? accept}
            multiselect={dropboxMultiselect ?? multiple}
            isDisabled={disabled || isLoading}
            className={dropboxClassName}
            onSuccess={onDropboxSuccess}
          />
        </div>
      )}
    </div>
  );
};

export default UploadButtonGroup;
